import { JWTPayloadModel } from '../../models/jwtPayloadModel';
import { PersonRole } from '../../models/eums/personRole';

export const LOAD_TOKEN_REQ = '@@auth/LOAD_TOKEN_REQ';
export const LOAD_TOKEN_RES = '@@auth/LOAD_TOKEN_RES';
export const LOG_IN_REQ = '@@auth/LOG_IN_REQ';
export const LOG_IN_RES = '@@auth/LOG_IN_RES';
export const LOG_OUT_REQ = '@@auth/LOG_OUT_REQ';
export const LOG_OUT_RES = '@@auth/LOG_OUT_RES';
export const FAILED_REQUEST = '@@auth/REQUEST_FAIL';

interface LoginAction {
  type:
    | typeof LOAD_TOKEN_REQ
    | typeof LOAD_TOKEN_RES
    | typeof LOG_IN_REQ
    | typeof LOG_IN_RES
    | typeof LOG_OUT_REQ
    | typeof LOG_OUT_RES;
  payload?: JWTPayloadModel;
}

interface ErrorAction {
  type: typeof FAILED_REQUEST;
  payload: string;
}

export interface AuthState {
  authenticated: boolean;
  personFirstName?: string;
  personLastName?: string;
  personId?: string;
  personRoles?: PersonRole[];
  loading: boolean;
}

export type AuthActionTypes =
  | LoginAction
  | ErrorAction /* | SecondAction | ThirdAction | continue building here.. */;
